'use strict';

var _ = require('lodash');
var d3 = require('d3');
var Scales = function Scales(params, data) {
  /*
  The scales function has to account for every data
  that is used to generate bars, circles and tiles
  so that nothing will be cut out of the chart
   */

  var yMin = d3.min(data, function (d) {
    return Math.min(0, d.m1, d.m2, d.m3 || 0, d.m4 || 0);
  });
  var yMax = d3.max(data, function (d) {
    return Math.max(0, d.m1, d.m2, d.m3 || 0, d.m4 || 0);
  });
  var x = d3.scale.ordinal().domain(_.map(data, 'label')).rangeBands([0, params.width], 0.1, 0.05);
  var y = d3.scale.linear().domain([yMin, yMax]).range([params.height, 0]);
  return {
    xScale: x,
    yScale: y
  };
};
Scales.$inject = [];
module.exports = Scales;